<template>

  <div class="page">
      <div class="gridheader">
        <div class="row wrapper">
          <div class="col-md-8 title">
            <div class="row">
              <div class="col-12 namescol">
                <a v-on:click="back"><img src="../assets/img/arrow-left-white.svg" alt=""></a>
                <h1>{{patientdata.name}} {{patientdata.surname}}</h1>
              </div>
            </div>
          </div>
          <!--div class="col-md-4">
            <form method="get" action="">
              <div class="input-group">
                <input type="text" v-model="pagination.query" class="form-control" v-bind:placeholder="$t('SEARCHWORKORDERS')">
                <div v-if="pagination.query == ''" class="input-group-addon"><img src="../assets/img/icon-search.svg" alt=""></div>
                <div v-if="pagination.query != ''" v-on:click="pagination.query = ''" class="input-group-addon"><img class="emptysearch" src="../assets/img/icon-close.svg" alt=""></div>
              </div>
            </form>
          </div-->
          <div class="col-md-4 action d-none d-md-block"><a v-on:click="addWorkOrder" class="btn btn-primary"><img src="../assets/img/icon-add-item.svg" alt=""> {{$t('ADDWORKORDER')}}</a></div>
        </div>
      </div>
      <div class="gridheader secondary">
        <div class="row d-none d-md-flex">
          <div class="col-md-8 title"><h2>{{$t('WORKORDERLIST')}}</h2></div>
          <div class="col-md-4 action"><a href="#" v-on:click.prevent="showPatientGallery" class="btn btn-primary"><img src="../assets/img/icon-gallery-small-white.svg" alt=""> {{$t('GALLERY')}}</a></div>
        </div>
        <div class="row d-md-none">
          <div class="col-10 title"><h2>{{$t('WORKORDERLIST')}}</h2></div>
          <div class="col-2 action"><a href="#" v-on:click.prevent="showPatientGallery"><img src="../assets/img/cell-camera.svg" alt=""></a></div>
        </div>
      </div>
      <div class="row" v-if="workorders.root.length == 0">
        <div class="col-12 center nothing">
          <img src="../assets/img/icon-novi-nalog-large.svg" alt="">
          <p>{{$t('CURRENTLYNOWORKORDERS')}}</p>
          <a v-on:click="addWorkOrder" class="btn btn-primary"><img src="../assets/img/icon-add-item.svg" alt=""> {{$t('ADDWORKORDER')}}</a>
        </div>
      </div>
      <div class="row" v-if="workorders.root.length > 0">
        <div class="table-responsive">
          <table class="maintable">
            <thead>
              <tr>
                <td>{{$t('NUM')}}</td>
                <td class="d-none d-md-table-cell">{{$t('OPENEDBY')}}</td>
                <td>{{$t('DOCTOR')}}</td>
                <td>{{$t('TECHNICIAN')}}</td>
                <td class="d-none d-md-table-cell">{{$t('OPENEDON')}}</td>
                <td class="d-none d-md-table-cell">{{$t('LASTCHANGE')}}</td>
                <td>{{$t('STATUS')}}</td>
                <td class="d-none d-md-table-cell">{{$t('ACTIONS')}}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="workorder in workorders.root">
                <td v-on:click="toWorkOrder(workorder.workOrderId)">{{workorder.workOrderId}}</td>
                <td class="d-none d-md-table-cell" v-on:click="toWorkOrder(workorder.workOrderId)">{{workorder.name}} {{workorder.surname}}</td>
                <td v-on:click="toWorkOrder(workorder.workOrderId)">{{workorder.doctorName}} {{workorder.doctorSurname}}</td>
                <td v-on:click="toWorkOrder(workorder.workOrderId)">{{workorder.tehnicianName}} {{workorder.technicianSurname}}</td>
                <td class="d-none d-md-table-cell" v-on:click="toWorkOrder(workorder.workOrderId)">{{formatDate(workorder.openDateTime)}} ({{workorder.name}} {{workorder.surname}})</td>
                <td class="d-none d-md-table-cell" v-on:click="toWorkOrder(workorder.workOrderId)">{{formatDate(workorder.updateDateTime)}} ({{workorder.updateName}} {{workorder.updateSurname}})</td>
                <td v-on:click="toWorkOrder(workorder.workOrderId)" class="status" v-bind:class="workorder.status">{{workorder.statusOut}}</td>
                <td class="d-none d-md-table-cell"><a href="#" class="grid-action" v-on:click.prevent="deleteWorkOrder(workorder.workOrderId)"><img src="../assets/img/icon-trash.svg" alt=""></a><a href="#" class="grid-action" v-on:click.prevent="editWorkOrder(workorder)"><img src="../assets/img/cell-edit.svg" alt=""></a></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <b-pagination align="center" v-if="workorders.totalCount > 20" :total-rows="parseInt(workorders.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>

      <b-modal centered size="lg" ref="newworkorder" id="newworkorder" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="saveWorkOrder" v-bind:title="$t('NEWWORKORDER')">
          <form method="get" action="">
            <div>
              <div class="row">
                <div class="col-md-12">
                  <inputvalidation v-bind:label="$t('OURUSER')" :formerror="formError" name="ourUserId">
                    <autocompletesimple v-model="formData.ourUserId" v-on:query="getOurUsersInit" v-bind:data="ourUsers" v-bind:placeholder="$t('OURUSER')" v-bind:valuekey="'userId'" v-bind:text="['name', 'surname']"></autocompletesimple>
                    <!-- select class="form-control secondary" v-model="formData.ourUserId">
                      <option v-for="user in ourUsers" v-bind:value="user.userId">{{user.name}} {{user.surname}}</option>
                    </select -->
                  </inputvalidation>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <b-form-checkbox value="real" v-model="formData.partnerType" class="grey"><span class="label">{{$t('REALPARTNER')}}</span></b-form-checkbox>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <b-form-checkbox value="dummy" v-model="formData.partnerType" class="grey"><span class="label">{{$t('DUMMYPARTNER')}}</span></b-form-checkbox>
                </div>
              </div>
            </div>
            <div class="row" v-if="globals.companyType != 'ordination' && globals.companyType != 'technicallab'">
              <div class="col-md-6">
                <div class="form-group">
                  <b-form-checkbox value="ordination" v-model="formData.companyType" class="grey"><span class="label">{{$t('ORDINATION')}}</span></b-form-checkbox>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <b-form-checkbox value="technicallab" v-model="formData.companyType" class="grey"><span class="label">{{$t('TECHNICALLAB')}}</span></b-form-checkbox>
                </div>
              </div>
            </div>
            <div v-if="formData.partnerType == 'dummy'">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group" v-bind:class="(formError.dummyPartner) ? 'has-danger' :''">
                    <label>{{ $t('PARTNERNAME')}}</label>
                    <input type="text" v-model="formData.dummyPartner" class="form-control secondary" v-bind:placeholder="$t('PARTNERNAME')">
                    <div v-if="formError.dummyPartner" class="form-control-feedback">{{formError.dummyPartner}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="formData.partnerType == 'real'">
              <div class="row" v-if="selecttype == 'ordination'">
                <div class="col-md-6">
                  <inputvalidation v-bind:label="$t('ORDINATION')" :formerror="formError" name="ordinationId"><autocomplete v-bind:setvalue="setOrdinationId" v-bind:value="formData.ordinationId" v-bind:placeholder="$t('ORDINATION')" v-bind:values="getOrdinationsOptions" v-bind:initdata="getOrdinationsInit"></autocomplete></inputvalidation>
                </div>
                <div class="col-md-6">
                  <inputvalidation v-bind:label="$t('ORDINATIONUSER')" :formerror="formError" name="ordinationUserId">
                    <autocompletesimple v-model="formData.ordinationUserId" v-on:query="getOrdinationUsers" v-bind:data="ordinationUsers" v-bind:placeholder="$t('ORDINATIONUSER')" v-bind:valuekey="'userId'" v-bind:text="['name', 'surname']"></autocompletesimple>
                    <!-- select class="form-control secondary" v-model="formData.ordinationUserId">
                      <option v-for="user in ordinationUsers" v-bind:value="user.userId">{{user.name}} {{user.surname}}</option>
                    </select -->
                  </inputvalidation>
                </div>
              </div>
              <div class="row" v-if="selecttype == 'technicallab'">
                <div class="col-md-6">
                  <inputvalidation v-bind:label="$t('TECHNICALLAB')" :formerror="formError" name="technicalLabId">
                    <autocomplete v-bind:setvalue="setTechnicalLabId" v-bind:value="formData.technicalLabId" v-bind:placeholder="$t('TECHNICALLAB')" v-bind:values="getTechnicalLabOptions" v-bind:initdata="getTehnicalLabsInit"></autocomplete>
                  </inputvalidation>
                </div>
                <div class="col-md-6">
                  <inputvalidation v-bind:label="$t('TECHNICALLABUSER')" :formerror="formError" name="tehnicianUserId">
                    <autocompletesimple v-model="formData.tehnicianUserId" v-on:query="getTechnicalLabUsers" v-bind:data="tehnicianUsers" v-bind:placeholder="$t('TECHNICALLABUSER')" v-bind:valuekey="'userId'" v-bind:text="['name', 'surname']"></autocompletesimple>
                    <!-- select class="form-control secondary" v-model="formData.tehnicianUserId">
                      <option v-for="user in tehnicianUsers" v-bind:value="user.userId">{{user.name}} {{user.surname}}</option>
                    </select -->
                  </inputvalidation>
                </div>
              </div>
            </div>
            <p class="bg-danger" v-if="formError.error && formError.notice">{{formError.notice}}</p>
            <div class="clearfix"></div>
          </form>
      </b-modal>

      <patientsgallery v-bind:patientId="galleryPatientId"></patientsgallery>

    </div>



</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import PatientsGallery from '@/components/PatientsGallery.vue'
import usersApi from '@/api/users'
import patientsApi from '@/api/patients'
import workordersApi from '@/api/workorders'

export default {
  name: 'WorkOrders',
  components:
  {
    'patientsgallery': PatientsGallery
  },
  data: function()
  {
    var me = this;
    return {
      patientId: false,
      galleryPatientId: false,
      patientdata: {},
      ourUsers: [],
      ordinationUsers: [],
      tehnicianUsers: [],
      workorders: {root: [], totalCount: 0},
      formData: {
        id: '',
        patientId: '',
        ordinationId: '',
        technicalLabId: '',
        ordinationUserId: '',
        tehnicianUserId: '',
        partnerType: 'real',
        dummyPartner: '',
        companyType: '',
        ourUserId: ''
      },
      formError: {},
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20
      }
    };
  },
  created: function()
  {
    var me = this;

    me.patientId = me.$route.params.patientId;
    me.formData.patientId =  me.patientId;
    this.getWorkOrders({patientId: me.patientId});

    patientsApi.getPatient({id: me.patientId}, function(data)
    {
      if(data.error && data.error == true)
      {
        Vue.$notify.error(data.notice);
        return;
      }
      me.patientdata = data.root;
      me.formData.ordinationId = me.patientdata.ordinationId;
      me.formData.technicalLabId = me.patientdata.technicalLabId;
      me.formData.dummyPartner = me.patientdata.dummyPartner;
      if(me.formData.dummyPartner != '')
      {
        me.formData.partnerType = 'dummy';
      }
    });

    me.getOurUsersInit({});

    if(me.globals.companyType == 'ordination') me.formData.companyType = 'technicallab';
    else me.formData.companyType = 'ordination';
  },
  methods:
  {
    ...mapActions({
      getOrdinations: 'getOrdinations',
      getTehnicalLabs: 'getTehnicalLabs',
      getPatientInit: 'getPatient',
      getUsersByCompanyIdInit: 'getUsersByCompanyId'
    }),
    getOurUsersInit(params)
    {
      var me = this,
        group = 'technicallab';

      if(me.selecttype == 'technicallab') group = 'ordination';

      usersApi.getUsersByCompanyId({...params, companyId: me.globals.companyId, userGroup: group}, function(data)
      {
        me.ourUsers = data.root;
      })
    },
    getOrdinationsInit: function()
    {
      var me = this;
      me.getOrdinations({onlyConnected: 'true'})
    },
    getTehnicalLabsInit: function()
    {
      var me = this;
      me.getTehnicalLabs({onlyConnected: 'true'})
    },
    toWorkOrder: function(workOrderId)
    {
      var me = this;
      me.$router.push('/workorders/'+workOrderId)
    },
    getPatient: function()
    {
      var me = this;
      this.getPatientInit({id: me.patientId});
    },
    showPatientGallery: function()
    {
      var me = this;
      me.galleryPatientId = false;
      Vue.nextTick(function()
      {
        me.galleryPatientId = me.patientId;
      })
    },
    saveWorkOrder: function(bvEvt)
    {
      var me = this;
      bvEvt.preventDefault();

      workordersApi.saveWorkOrder(me.formData, function(val)
      {
        if(val.error)
        {
          if(typeof val.notice == 'object')
          {
            var notice = '';
            for(var key in val.notice)
            {
              notice += val.notice[key];
            }
            val.notice = notice;
          }
          me.formError = val;
        }
        else
        {
          me.$refs.newworkorder.hide()
          me.$router.push('/workorders/'+val.lastId)
        }
      })
    },
    getWorkOrders: function()
    {
      var me = this;
      workordersApi.getWorkOrders(me.getParams, function(data)
      {
        if(data.error && data.error == true)
        {
          Vue.$notify.error(data.notice);
          return;
        }
        me.workorders = data;
      });
    },
    deleteWorkOrder: function(id)
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          workordersApi.deleteWorkOrder({id: id}, function(data)
          {
            if(data.error && data.error == true) me.$notify.error(data.notice);
            else me.$notify.success(data.notice);
            me.getWorkOrders();
          })
        }
      })
    },
    addWorkOrder()
    {
      var me = this;
      me.formData =
      {
        id: '',
        patientId: me.patientId,
        ordinationId: '',
        technicalLabId: '',
        ordinationUserId: '',
        tehnicianUserId: '',
        partnerType: 'real',
        dummyPartner: '',
        companyType: (me.globals.companyType == 'ordination') ? 'technicallab' : 'ordination',
        ourUserId: ''
      };

      me.formData.ordinationId = me.patientdata.ordinationId;
      me.formData.technicalLabId = me.patientdata.technicalLabId;
      me.formData.dummyPartner = me.patientdata.dummyPartner;
      if(me.formData.dummyPartner != '')
      {
        me.formData.partnerType = 'dummy';
      }

      me.$refs.newworkorder.show()
    },
    editWorkOrder: function(data)
    {
      var me = this;
      data = Object.assign({}, data, {});
      data.id = data.workOrderId;
      if(data.dummyPartner != '')
      {
        data.partnerType = 'dummy';
      }

      if(data.ordinationId != '')
      {
        data.companyType = 'ordination';
      }

      if(data.ordinationId == me.globals.companyId)
      {
        data.ourUserId = data.ordinationUserId;
      }
      else
      {
        data.ourUserId = data.tehnicianUserId;
      }
      me.formData = data;
      me.$refs.newworkorder.show()
    },
    setOrdinationId: function(data)
    {
      var me = this;
      me.formData.ordinationId = data;
      me.getOrdinationUsers({});
    },
    setTechnicalLabId: function(data)
    {
      var me = this;
      me.formData.technicalLabId = data;
      me.getTechnicalLabUsers({});
    },
    setTechnicalLabUserId: function(data)
    {
      var me = this;
      me.formData.tehnicianUserId = data;
    },
    getTechnicalLabUsers: function(params)
    {
      var me = this;
      usersApi.getUsersByCompanyId({...params, companyId: me.formData.technicalLabId, userGroup: 'technicallab'}, function(data)
      {
        me.tehnicianUsers = data.root;
      })
    },
    getOrdinationUsers: function(params)
    {
      var me = this;
      usersApi.getUsersByCompanyId({...params, companyId: me.formData.ordinationId, userGroup: 'ordination'}, function(data)
      {
        me.ordinationUsers = data.root;
      })
    }
  },
  watch:
  {
    patient: function(val)
    {
      var me = this;
      me.$refs.patientgallery.show()
    },
    saveWorkOrderResponse: function(val)
    {
      var me = this;

      me.formError = {};

      if(val.error == true)
      {
        if(typeof val.notice == 'object')
        {
          me.formError = val.notice;
          val.notice = '';
        }
      }
      else
      {
        this.$refs.newworkorder.hide()
        me.getWorkOrders();
        for(var key in me.formData)
        {
          me.formData[key] = '';
        }
      }
    },
    'pagination.query': function()
    {
      var me = this;
      me.getWorkOrders();
    },
    'pagination.currentPage': function(newValue, oldValue)
    {
      var me = this;
      me.getWorkOrders();
    },
    'formData.companyType': function()
    {
      var me = this;
      me.getOurUsersInit({});
    }
  },
  computed:
  {
    ...mapGetters([
      'modalAlert',
      'ordinations',
      'tehnicallabs',
      'globals'
    ]),
    selecttype: function()
    {
      var me = this;
      //'admin','ordination','technicallab','ordinationandlab'
      if(me.globals.companyType == 'ordination')
      {
        return 'technicallab';
      }

      if(me.globals.companyType == 'technicallab')
      {
        return 'ordination';
      }

      if(me.formData.companyType == 'ordination')
      {
        return 'ordination';
      }

      if(me.formData.companyType == 'technicallab')
      {
        return 'technicallab';
      }
    },
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      data.patientId = me.patientId;
      return data;
    },
    getOrdinationsOptions: function()
    {
      var me = this,
        options = [];

      for(var i=0;i<me.ordinations.root.length;i++)
      {
        var ordination = me.ordinations.root[i];
        options.push({value: ordination.companyId, text: ordination.companyName})
      }

      return options;
    },
    getTechnicalLabOptions: function()
    {
      var me = this,
        options = [];

      for(var i=0;i<me.tehnicallabs.root.length;i++)
      {
        var tehnicallab = me.tehnicallabs.root[i];
        options.push({value: tehnicallab.companyId, text: tehnicallab.companyName})
      }

      return options;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WorkOrders.vue